import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { CommonService } from "src/app/service/common.service";
import { ItemLimitParamDto } from "src/app/webservice/item-param-limit";

export class ItemLimitParamRec {

  public storeCd:           string;
  public storeName:         string;
  public itemCd:            string;
  public orderStopFlag:     number;
  public orderStopFlagName: string;
  public minZai:            number;
  public maxZai:            number;
  public minStockDays:      number;
  public maxStockDays:      number;
  public minZaiCtg:         number;
  public maxZaiCtg:         number;
  public minStockDaysCtg:   number;
  public maxStockDaysCtg:   number;
  public minZaiLim:         number;
  public maxZaiLim:         number;
  public minStockDaysLim:   number;
  public maxStockDaysLim:   number;
  public dateBegin:         string;
  public dateEnd:           string;

  public edit: {
    isDirty:                boolean;
    isError:                boolean;
    updRequired:                boolean;
    minZaiLim:              FormControl;
    maxZaiLim:              FormControl;
    minStockDaysLim:        FormControl;
    maxStockDaysLim:        FormControl;
    dateBegin:              FormControl;
    dateEnd:                FormControl;
    minZaiErr:              boolean;
    maxZaiErr:              boolean;
    minStockDaysErr:        boolean;
    maxStockDaysErr:        boolean;
    errorMsg:               string[];
  }

  private changeListener: (item: ItemLimitParamRec)=>void;
  private subsc: Subscription[] = [];
  
  constructor(private commonService: CommonService) {
  }

  initByDto(itemSimpleDto: ItemLimitParamDto) {
    for (var key of Object.keys(itemSimpleDto)) {
      this[key] = itemSimpleDto[key];
    }
    let flag = this.commonService.config.orderStopFlag.find((flag) => flag.value == this.orderStopFlag);
    if (flag) {
      if (flag.isAutoOrder) {
        this.orderStopFlagName = "自動発注対象";
      } else {
        this.orderStopFlagName = "自動発注停止";
      }
    } else {
      this.orderStopFlagName = "";
    }
  }

  prepareEdit() {
    if (this.edit) this.cleanupEdit();

    this.edit = {
      isDirty:                false,
      isError:                false,
      updRequired:            false,
      minZaiLim:              new FormControl(this.minZaiLim <= 0 ? "" : this.minZaiLim),
      maxZaiLim:              new FormControl(this.maxZaiLim <= 0 ? "" : this.maxZaiLim),
      minStockDaysLim:        new FormControl(this.minStockDaysLim <= 0 ? "" : this.minStockDaysLim),
      maxStockDaysLim:        new FormControl(this.maxStockDaysLim <= 0 ? "" : this.maxStockDaysLim),
      dateBegin:              new FormControl(this.dateBegin === "" ? null : this.commonService.getDate(this.dateBegin)),
      dateEnd:                new FormControl(this.dateEnd === "" ? null : this.commonService.getDate(this.dateEnd)),
      minZaiErr:              false,
      maxZaiErr:              false,
      minStockDaysErr:        false,
      maxStockDaysErr:        false,
      errorMsg:               []
    }

    this.subsc.push(this.edit.minZaiLim.valueChanges.subscribe(() => { this.checkError(); this.setDirty(); }));
    this.subsc.push(this.edit.maxZaiLim.valueChanges.subscribe(() => { this.checkError(); this.setDirty(); }));
    this.subsc.push(this.edit.minStockDaysLim.valueChanges.subscribe(() => { this.checkError(); this.setDirty(); }));
    this.subsc.push(this.edit.maxStockDaysLim.valueChanges.subscribe(() => { this.checkError(); this.setDirty(); }));
    this.subsc.push(this.edit.dateBegin.valueChanges.subscribe(() => { this.dateCheck("begin"); this.checkError(); this.setDirty();}));
    this.subsc.push(this.edit.dateEnd.valueChanges.subscribe(() => { this.dateCheck("end"); this.checkError(); this.setDirty();}));

    if (!this.commonService.config.paramItemLimitMinZaiEditable) this.edit.minZaiLim.disable();
    if (!this.commonService.config.paramItemLimitMaxZaiEditable) this.edit.maxZaiLim.disable();
    if (!this.commonService.config.paramItemLimitMinStockDaysEditable) this.edit.minStockDaysLim.disable();
    if (!this.commonService.config.paramItemLimitMaxStockDaysEditable) this.edit.maxStockDaysLim.disable();

    let today = this.commonService.getToday();
    let begin = this.edit.dateBegin.value;
    let end = this.edit.dateEnd.value;
    if (begin && begin.getTime() < today.getTime()) {
      this.edit.minZaiLim.disable();
      this.edit.maxZaiLim.disable();
      this.edit.minStockDaysLim.disable();
      this.edit.maxStockDaysLim.disable();
      this.edit.dateBegin.disable();
    }
  }

  setChangeListener(f: ()=>void) {
    this.changeListener = f;
  }

  cleanupEdit() {
    this.subsc.forEach((subsc) => subsc.unsubscribe());
    this.subsc = [];
  }

  cancelEdit() {
    this.cleanupEdit();
    this.prepareEdit();
  }

  dateCheck(which: string) {
    let begin: Date = this.edit.dateBegin.value;
    let end: Date = this.edit.dateEnd.value;
    if (begin !== null && end !== null) {
      if (begin.getTime() > end.getTime()) {
        if (which === "begin") {
          this.edit.dateEnd.setValue(this.commonService.copyDate(begin), {emitEvent: false});
        } else {
          this.edit.dateBegin.setValue(this.commonService.copyDate(end), {emitEvent: false});
        }
      }
    }
  }

  setDirty() {
    this.edit.updRequired = false;
    if (this.checkDirty()) {
      this.edit.isDirty = true;
      if (this.dateBegin !== "") {
        // this is DB rec
        this.edit.updRequired = true;
      } else {
        if (
          this.edit.minZaiLim.value !== "" ||
          this.edit.maxZaiLim.value !== "" ||
          this.edit.minStockDaysLim.value !== "" ||
          this.edit.maxStockDaysLim.value !== ""
        ) {
          this.edit.updRequired = true;
        }
      }
    } else {
      this.edit.isDirty = false;
    }


    if (this.changeListener) {
      this.changeListener(this);
    }
  }

  checkDirty() {
    if (!this.isSameValue(this.edit.minZaiLim.value, this.minZaiLim)) return true;
    if (!this.isSameValue(this.edit.maxZaiLim.value, this.maxZaiLim)) return true;
    if (!this.isSameValue(this.edit.minStockDaysLim.value, this.minStockDaysLim)) return true;
    if (!this.isSameValue(this.edit.maxStockDaysLim.value, this.maxStockDaysLim)) return true;
    if (!this.isSameValueDate(this.edit.dateBegin.value, this.dateBegin)) return true;
    if (!this.isSameValueDate(this.edit.dateEnd.value, this.dateEnd)) return true;
    return false;
  }

  isSameValue(formVal: string, orgVal: number) {
    if (formVal === "" && orgVal < 0) return true;
    if (parseInt(formVal) === orgVal) return true;
    return false;
  }

  isSameValueDate(formVal: Date, orgVal: string) {
    if (!formVal && orgVal === "") return true;
    if (!formVal) return false;
    if (orgVal === "") return false;
    if (this.commonService.formatDate(formVal) === orgVal) return true;
    return false;
  }

  checkError() {
    this.edit.errorMsg = [];
    this.edit.isError = false;
    this.edit.minZaiErr = false;
    this.edit.maxZaiErr = false;
    this.edit.minStockDaysErr = false;
    this.edit.maxStockDaysErr = false;

    this.checkRange();
    this.checkMinMax();
    this.checkDate();
  }

  checkRange() {
    let config = this.commonService.config;
    if (this.edit.minZaiLim.value !== "" && config.paramItemLimitMinZaiRange) {
      let value = parseInt(this.edit.minZaiLim.value);
      let min = config.paramItemLimitMinZaiRange.min;
      let max = config.paramItemLimitMinZaiRange.max;
      if (value < min || value > max) {
        this.edit.isError = true;
        this.edit.minZaiErr = true;
        this.edit.errorMsg.push("最低陳列の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
    if (this.edit.maxZaiLim.value !== "" && config.paramItemLimitMaxZaiRange) {
      let value = parseInt(this.edit.maxZaiLim.value);
      let min = config.paramItemLimitMaxZaiRange.min;
      let max = config.paramItemLimitMaxZaiRange.max;
      if (value < min || value > max) {
        this.edit.isError = true;
        this.edit.maxZaiErr = true;
        this.edit.errorMsg.push("最大陳列の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
    if (this.edit.minStockDaysLim.value !== "" && config.paramItemLimitMinStockDaysRange) {
      let value = parseInt(this.edit.minStockDaysLim.value);
      let min = config.paramItemLimitMinStockDaysRange.min;
      let max = config.paramItemLimitMinStockDaysRange.max;
      if (value < min || value > max) {
        this.edit.isError = true;
        this.edit.minStockDaysErr = true;
        this.edit.errorMsg.push("最低在庫日数の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
    if (this.edit.maxStockDaysLim.value !== "" && config.paramItemLimitMaxStockDaysRange) {
      let value = parseInt(this.edit.maxStockDaysLim.value);
      let min = config.paramItemLimitMaxStockDaysRange.min;
      let max = config.paramItemLimitMaxStockDaysRange.max;
      if (value < min || value > max) {
        this.edit.isError = true;
        this.edit.maxStockDaysErr = true;
        this.edit.errorMsg.push("最大在庫日数の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
  }

  checkMinMax() {
    var minValue: number;
    var maxValue: number;

    if (this.edit.minZaiLim.value !== "") {
      minValue = parseInt(this.edit.minZaiLim.value);
      if (this.edit.maxZaiLim.value !== "") {
        maxValue = parseInt(this.edit.maxZaiLim.value);
        if (minValue > maxValue) {
          this.edit.isError = true;
          this.edit.minZaiErr = true;
          this.edit.maxZaiErr = true;
          this.edit.errorMsg.push("最低陳列と最大陳列の大小関係が逆転しています。")
        }
      } else {
        maxValue = this.getValue("maxZai");
        if (minValue > maxValue) {
          this.edit.isError = true;
          this.edit.minZaiErr = true;
          this.edit.errorMsg.push("最低陳列と最大陳列（元）の大小関係が逆転しています。")
        }
      }
    } else {
      minValue = this.getValue("minZai");
      if (this.edit.maxZaiLim.value !== "") {
        maxValue = parseInt(this.edit.maxZaiLim.value);
        if (minValue > maxValue) {
          this.edit.isError = true;
          this.edit.maxZaiErr = true;
          this.edit.errorMsg.push("最低陳列(元)と最大陳列の大小関係が逆転しています。")
        }
      }
    }

    if (this.edit.minStockDaysLim.value !== "") {
      minValue = parseInt(this.edit.minStockDaysLim.value);
      if (this.edit.maxStockDaysLim.value !== "") {
        maxValue = parseInt(this.edit.maxStockDaysLim.value);
        if (minValue > maxValue) {
          this.edit.isError = true;
          this.edit.minStockDaysErr = true;
          this.edit.maxStockDaysErr = true;
          this.edit.errorMsg.push("最低在庫日数と最大在庫日数の大小関係が逆転しています。")
        }
      } else {
        maxValue = this.getValue("maxStockDays");
        if (minValue > maxValue) {
          this.edit.isError = true;
          this.edit.minStockDaysErr = true;
          this.edit.errorMsg.push("最低在庫日数と最大在庫日数（元）の大小関係が逆転しています。")
        }
      }
    } else {
      minValue = this.getValue("minStockDays");
      if (this.edit.maxStockDaysLim.value !== "") {
        maxValue = parseInt(this.edit.maxStockDaysLim.value);
        if (minValue > maxValue) {
          this.edit.isError = true;
          this.edit.maxStockDaysErr = true;
          this.edit.errorMsg.push("最低在庫日数(元)と最大在庫日数の大小関係が逆転しています。")
        }
      }
    }
  }

  checkDate() {
    if (this.edit.updRequired && !(
      this.edit.minZaiLim.value === "" &&
      this.edit.maxZaiLim.value === "" &&
      this.edit.minStockDaysLim.value === "" &&
      this.edit.maxStockDaysLim.value === ""
    )) {
      if (!this.edit.dateBegin.value) {
        this.edit.isError = true;
        this.edit.errorMsg.push("開始日が設定されていません。")
      }
      if (!this.edit.dateEnd.value) {
        this.edit.isError = true;
        this.edit.errorMsg.push("終了日が設定されていません。")
      }
    }
  }

  showError() {
    let msg = "";
    this.edit.errorMsg.forEach((err) => msg += err + "<br>");

    this.commonService.openErrorDialog(this.commonService.pageTitle, msg);
  }

  getValue(key: string) {
    switch(key) {
      case "storeCdName": {
        return this.storeCd + ":" + this.storeName;
      }
      case "minZai": {
        return this.minZai <= 0 ? this.minZaiCtg : this.minZai;
      };
      case "maxZai": {
        return this.maxZai <= 0 ? this.maxZaiCtg : this.maxZai;
      };
      case "minStockDays": {
        return this.minStockDays <= 0 ? this.minStockDaysCtg : this.minStockDays;
      };
      case "maxStockDays": {
        return this.maxStockDays <= 0 ? this.maxStockDaysCtg : this.maxStockDays;
      };
      case "minZaiLim": {
        return this.edit.minZaiLim.value;
      };
      case "maxZaiLim": {
        return this.edit.minZaiLim.value;
      };
      case "minStockDaysLim": {
        return this.edit.minStockDaysLim.value;
      };
      case "maxStockDaysLim": {
        return this.edit.maxStockDaysLim.value;
      };

      default: {
        return this[key];
      }
    };
  }

}